import React from 'react'
import { Form, Input, Button, Icon, Switch } from 'antd'

class CreateChannel extends React.Component {
    handleSubmit = e => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.onSubmit(values)
                this.props.form.resetFields()
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const { loadingAnswer } = this.props

        return (
            <Form layout="vertical" onSubmit={this.handleSubmit}>
                <Form.Item>
                    {getFieldDecorator('channel', {
                        rules: [{ required: false }]
                    })(
                        <Input
                            prefix={<Icon type="deployment-unit" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            placeholder="Channel ID (optionnal)"
                        />
                    )}
                </Form.Item>

                {/* <Form.Item label="Private">
                    {getFieldDecorator('switch_private', { valuePropName: 'checked' })(<Switch />)}
                </Form.Item> */}

                <Form.Item>
                    <Button type="primary" htmlType="submit" className="login-form-button">
                        {loadingAnswer === true ? (
                            <Icon type="loading" style={{ fontSize: 24, padding: 4 }} spin />
                        ) : (
                            <span>Create Channel</span>
                        )}
                    </Button>
                </Form.Item>
            </Form>
        )
    }
}

const FormCreateChannel = Form.create({ name: 'create_channel' })(CreateChannel)

export default FormCreateChannel
